document.addEventListener('DOMContentLoaded', function () {
  const swiperFits = new Swiper('.supplements__fits-you .swiper', {
    slidesPerView: 'auto',
    loop: true,
    pagination: {
      el: '.supplements__fits-you .swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        speed: 500,
        centeredSlides: true,
        slidesPerGroupAuto: false,
        loop: true,
        spaceBetween: 0,
        navigation: {
          prevEl: '.supplements__fits-you .slider-prev',
          nextEl: '.supplements__fits-you .slider-next'
        }
      }
    },
    on: {
      init(swiper) {
        if (window.innerWidth < 768) return;

        const paginationEl = swiper.pagination.el;
        if (!paginationEl) return;

        const wrapEl = paginationEl.closest('.swiper-pagination__wrap');
        if (!wrapEl) return;

        const raw = paginationEl.dataset.names;
        let names = [];

        try {
          names = JSON.parse(raw);
        } catch (e) {}

        const bullets = paginationEl.querySelectorAll(
          '.swiper-pagination-bullet'
        );
        bullets.forEach((bullet, i) => {
          if (names[i]) {
            bullet.textContent = String(names[i]).trim();
          }
        });

        let indicator = wrapEl.querySelector('.pagination-indicator');
        if (!indicator) {
          indicator = document.createElement('span');
          indicator.className =
            'pagination-indicator tw-absolute tw-left-0 tw-top-0 tw-h-full tw-rounded-x10 tw-bg-[#EBE1D3] tw-transition-all tw-duration-500 tw-opacity-0';
          wrapEl.insertBefore(indicator, wrapEl.firstChild);
        }

        const setIndicatorPosition = () => {
          const activeBullet = paginationEl.querySelector(
            '.swiper-pagination-bullet-active'
          );
          if (!activeBullet) return;

          const wrapRect = wrapEl.getBoundingClientRect();
          const bulletRect = activeBullet.getBoundingClientRect();

          indicator.style.width = bulletRect.width + 'px';
          indicator.style.left = bulletRect.left - wrapRect.left + 'px';
        };

        setIndicatorPosition();
        setTimeout(() => {
          indicator.classList.remove('tw-opacity-0');
        }, 300);

        swiper._setPaginationIndicator = setIndicatorPosition;
      },

      slideChange(swiper) {
        if (window.innerWidth < 768) return;

        if (typeof swiper._setPaginationIndicator === 'function') {
          swiper._setPaginationIndicator();
        }
      }
    }
  });
  swiperFits.on('realIndexChange', swiper => {
    calculateScrollPercentage(swiper, '.supplements__fits-you .title');
  });
});
